<template>
  <section>
    <div class="col-sm-12">
        <HalfCircleSpinner :animation-duration="2000" style="margin: 200px auto; float: none;" :size="80" :color="'#ec4141'"/>
    </div>
  </section>
</template>
<script>

import {HalfCircleSpinner} from 'epic-spinners'

export default {
  components: {
    HalfCircleSpinner
  },
  computed: {
    token () {
      return this.$store.state.login.loginUsuario.token
    }
  },
  data () {
    return {
      env: process.env
    }
  },
  mounted () {
    this.validarAdministrativo()
  },
  methods: {
    validarAdministrativo () {
      let vm = this
      vm.$axios.post(`${vm.env.AUTENTICA}/validarTokenTemporario`, {sistema: 'adm'}, {
        headers: {
          'Authorization': `Bearer ${vm.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        window.location.href = `${vm.env.ADMINISTRATIVO}/autenticar?hash=${response.data}`
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// RedirecionarAdministrativo.vue?6997ebcf